import React from 'react';

import { Frame } from './Frame';
import { PersonalInformation } from './PersonalInformation';
import { Search } from './Search';
import { ChangePassword } from './ChangePassword';
import { Notification } from './Notification';
import { ConsultationCharges } from './ConsultationCharges';
import { Question } from './Question';
import { Location } from './Location';
import { Vitamins } from './Vitamins';
import { Wallet } from './Wallet';
import { Close } from './Close';
import { Download2 } from './Download2';
import { Plus } from './Plus';
import { Camera } from './Camera';
import { Dots } from './Dots';
import { Mic } from './Mic';
import { Paperclip } from './Paperclip';
import { Send } from './Send';
import { Video } from './Video';
import { Delete } from './Delete';
import { Edit } from './Edit';
import { EyeFill } from './EyeFill';
import { Like } from './Like';
import { Up } from './Up';
import { Down } from './Down';
import { Pdf } from './Pdf';
import { File } from './File';
import { Clipboard } from './Clipboard';
import { Left } from './Left';
import { Right } from './Right';
import { Calendar } from './Calendar';
import { Download } from './Download';
import { Check } from './Check';
import { Setting } from './Setting';
import { Minus } from './Minus';
import { EyeFillSlash } from './EyeFillSlash';
import { Link } from './Link';
import { Card } from './Card';
import { BackArrow } from './BackArrow';
import { Phone } from './Phone';
import { Hamburg } from './Hamburg';
import { PhoneFill } from './PhoneFill';
import { Email } from './Email';
import { Gallery } from './Gallery';
import { Facebook } from './Facebook';
import { Instagram } from './Instagram';
import { Clock } from './Clock';
import { QuestionFill } from './QuestionFill';
import { Printer } from './Printer';
import { FilePDF } from './FilePDF';
import { FilePDF2 } from './FilePDF2';
import { FilePDF3 } from './FilePDF3';
import { FileDOC } from './FileDOC';
import { FileDCM } from './FileDCM';
import { FileXLS } from './FileXLS';
import { MessageCheck } from './MessageCheck';
import { Google } from './Google';
import { FileX } from './FileX';

const IconComponents = {
  PERSONAL_INFORMATION: PersonalInformation,
  DOWNLOAD2: Download2,
  CHANGE_PASSWORD: ChangePassword,
  NOTIFICATION: Notification,
  CONSULTATION_CHARGES: ConsultationCharges,
  QUESTION: Question,
  LOCATION: Location,
  VITAMINS: Vitamins,
  WALLET: Wallet,
  CLOSE: Close,
  PLUS: Plus,
  CAMERA: Camera,
  DOTS: Dots,
  MIC: Mic,
  PAPERCLIP: Paperclip,
  SEND: Send,
  VIDEO: Video,
  DELETE: Delete,
  EDIT: Edit,
  EYE_FILL: EyeFill,
  EYE_FILL_SLASH: EyeFillSlash,
  LIKE: Like,
  UP: Up,
  DOWN: Down,
  PDF: Pdf,
  FILE: File,
  CLIPBOARD: Clipboard,
  SEARCH: Search,
  LEFT: Left,
  RIGHT: Right,
  CALENDAR: Calendar,
  DOWNLOAD: Download,
  CHECK: Check,
  SETTING: Setting,
  MINUS: Minus,
  LINK: Link,
  CARD: Card,
  BACK_ARROW: BackArrow,
  PHONE: Phone,
  HAMBURG: Hamburg,
  PHONE_FILL: PhoneFill,
  EMAIL: Email,
  GALLERY: Gallery,
  FACEBOOK: Facebook,
  INSTAGRAM: Instagram,
  CLOCK: Clock,
  QUESTION_FILL: QuestionFill,
  PRINTER: Printer,
  FILE_PDF: FilePDF,
  FILE_PDF2: FilePDF2,
  FILE_PDF3: FilePDF3,
  FILE_DOC: FileDOC,
  FILE_DCM: FileDCM,
  FILE_XLS: FileXLS,
  FILE_X: FileX,
  MESSAGE_CHECK: MessageCheck,
  GOOGLE: Google
};
export const BASE_ICONS = {
  DOWNLOAD2: 'DOWNLOAD2',
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  NOTIFICATION: 'NOTIFICATION',
  CONSULTATION_CHARGES: 'CONSULTATION_CHARGES',
  QUESTION: 'QUESTION',
  LOCATION: 'LOCATION',
  VITAMINS: 'VITAMINS',
  WALLET: 'WALLET',
  CLOSE: 'CLOSE',
  PLUS: 'PLUS',
  CAMERA: 'CAMERA',
  DOTS: 'DOTS',
  MIC: 'MIC',
  PAPERCLIP: 'PAPERCLIP',
  SEND: 'SEND',
  VIDEO: 'VIDEO',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  EYE_FILL: 'EYE_FILL',
  EYE_FILL_SLASH: 'EYE_FILL_SLASH',
  LIKE: 'LIKE',
  UP: 'UP',
  DOWN: 'DOWN',
  PDF: 'PDF',
  FILE: 'FILE',
  FILE_X: 'FILE_X',
  CLIPBOARD: 'CLIPBOARD',
  SEARCH: 'SEARCH',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CALENDAR: 'CALENDAR',
  DOWNLOAD: 'DOWNLOAD',
  CHECK: 'CHECK',
  SETTING: 'SETTING',
  MINUS: 'MINUS',
  LINK: 'LINK',
  CARD: 'CARD',
  BACK_ARROW: 'BACK_ARROW',
  PHONE: 'PHONE',
  HAMBURG: 'HAMBURG',
  PHONE_FILL: 'PHONE_FILL',
  EMAIL: 'EMAIL',
  GALLERY: 'GALLERY',
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  CLOCK: 'CLOCK',
  QUESTION_FILL: 'QUESTION_FILL',
  PRINTER: 'PRINTER',
  FILE_PDF: 'FILE_PDF',
  FILE_PDF2: 'FILE_PDF2',
  FILE_PDF3: 'FILE_PDF3',
  FILE_DOC: 'FILE_DOC',
  FILE_DCM: 'FILE_DCM',
  FILE_XLS: 'FILE_XLS',
  MESSAGE_CHECK: 'MESSAGE_CHECK',
  GOOGLE: 'GOOGLE'
};

export const SVGBaseIcon = ({ iconname, ...props }) => {
  if (!BASE_ICONS[iconname]) {
    return null;
  }
  let defaultProps = {
    viewSize: 30
  };
  switch (iconname) {
    case BASE_ICONS.QUESTION_FILL:
      defaultProps.viewSize = 512;
      break;
    case BASE_ICONS.PHONE_FILL:
    case BASE_ICONS.EMAIL:
      defaultProps.viewSize = 25;
      break;
    case BASE_ICONS.PRINTER:
    case BASE_ICONS.GALLERY:
    case BASE_ICONS.CLOCK:
    case BASE_ICONS.MESSAGE_CHECK:
      defaultProps.viewSize = 24;
      defaultProps.padding = 3;
      break;
    case BASE_ICONS.FACEBOOK:
    case BASE_ICONS.INSTAGRAM:
      defaultProps.viewSize = 40;
      break;
    case BASE_ICONS.DOWNLOAD2:
    case BASE_ICONS.EDIT:
      defaultProps.viewSize = 24;
      break;
    case BASE_ICONS.GOOGLE:
      defaultProps.viewSize = 48;
      break;
    case BASE_ICONS.FILE_PDF:
    case BASE_ICONS.FILE_DOC:
    case BASE_ICONS.FILE_XLS:
    case BASE_ICONS.FILE:
      defaultProps.viewSize = 32;
      break;
    default:
      break;
  }

  return <Frame {...defaultProps} {...props} Icon={IconComponents[BASE_ICONS[iconname]]} />;
};
